import React, { useEffect, useRef, useState } from "react";
import {
    Tooltip
  } from "reactstrap";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import Navbar from "../../components/HorizontalLayout/Navbar";
import Header from "../../components/HorizontalLayout/Header";

const CustomTooltip = (props) => {
  const location = useLocation();
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const {tooltipText, titleText} = props;
  return (
    <React.Fragment>
        <p className="mb-0" ref={ref}>{titleText} <i className="mdi mdi-help-circle"></i></p>
        <Tooltip
            isOpen={isOpen}
            target={ref}
            placement="bottom"
            toggle={()=>{
                setIsOpen(!isOpen);
            }}
            style={{ cursor: "pointer" }}
        >
            {tooltipText}
        </Tooltip>
    </React.Fragment>
  );
};

export default CustomTooltip;
